import React from "react";
import { AppBar } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import NavigationBarLogo from "@/src/components/Navigation/NavigationBar/NavigationBarLogo";
import HeaderActionsAuthenticated from "@/src/components/Navigation/HeaderActionsAuthenticated/HeaderActionsAuthenticated";

export type NavigationBarDesktopAuthenticatedProps = {
  clickableLogo?: boolean;
};

export default function NavigationBarDesktopAuthenticated({ clickableLogo = true }: NavigationBarDesktopAuthenticatedProps) {
  return (
    <AppBar sx={(theme) => ({ backgroundColor: theme.palette.background.default })} elevation={0}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <NavigationBarLogo clickableLogo={clickableLogo} />
        <HeaderActionsAuthenticated />
      </Toolbar>
    </AppBar>
  );
}
